<template>
  <v-row class="text-white">
    <v-dialog v-model="dialog" max-width="500">
      <v-card class="orangeTop">
        <v-card-title>
          <v-icon class="warning-icon text-warning mr-3"> warning </v-icon>
          <span class="text-h5 fontWeight600">{{ $t('L_are_you_sure') }}</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <span aria-live="assertive">
              {{ $t('L_do_you_really_want_to_cancel') }} <br />
              {{ $t('L_all_previously_entered_informatoin_will') }}
            </span>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-row>
            <v-col>
              <OnexButton color="primary" flat="flat" @click="cancelThenGoToDashboard()">
                {{ $t('L_cancel_transaction') }}
              </OnexButton>
            </v-col>
            <v-col>
              <OnexButton color="primary" flat="flat" @click="$emit('hide-warning')">
                {{ $t('L_stay_on_this_screen') }}
              </OnexButton>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'WarningDialog',
  components: {
    OnexButton,
  },
  data: () => ({
    dialog: true,
  }),
  methods: {
    cancelThenGoToDashboard() {
      this.$emit('go-to-dashboard');
    },
  },
};

export default defineComponent(componentOptions);
</script>
<style lang="scss" scoped>
.close {
  float: right;
}
.orangeTop {
  border-top: 7px solid #ee7026;
}
.fontWeight600 {
  font-weight: 600;
}
</style>
